import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  ASSESSMENT_LIST,
  CREATE_INTERVIEW_SCHEDULE,
  GET_DROPDOWN_API,
  GET_INTERVIEW_QUESTIONS,
  GET_INTERVIEW_SCHEDULE_LIST,
  GET_MATCHED_CANDIDATES_LIST,
  SUBMIT_INTERVIEW_ASSESSMENT,
} from "helpers/url_helper"

export const getInterviewsScheduleList = createAsyncThunk(
  GET_INTERVIEW_SCHEDULE_LIST,
  async payload => {
    const response = await post(GET_INTERVIEW_SCHEDULE_LIST, payload)
    return response
  }
)

export const createInterviewSchedule = createAsyncThunk(
  CREATE_INTERVIEW_SCHEDULE,
  async payload => {
    const response = await post(CREATE_INTERVIEW_SCHEDULE, payload)
    return response
  }
)

export const getMatchedCandidatesList = createAsyncThunk(
  GET_MATCHED_CANDIDATES_LIST,
  async payload => {
    const response = await post(GET_MATCHED_CANDIDATES_LIST, payload)
    return response
  }
)

export const getAssessmentList = createAsyncThunk(
  ASSESSMENT_LIST,
  async payload => {
    const response = await post(ASSESSMENT_LIST, payload)
    return response
  }
)

export const getInterviewQuestions = createAsyncThunk(
  GET_INTERVIEW_QUESTIONS,
  async () => {
    const response = await get(GET_INTERVIEW_QUESTIONS)
    return response
  }
)

export const submitInterviewAssessment = createAsyncThunk(
  SUBMIT_INTERVIEW_ASSESSMENT,
  async data => {
    const { uuid, payload } = data
    const response = await post(
      `${SUBMIT_INTERVIEW_ASSESSMENT}/${uuid}`,
      payload
    )
    return response
  }
)
